import styled, { css } from 'styled-components'

const ATagButton = styled.a`
    background: transparent;
    border-radius: 3px;
    border: 1px solid #347EF6;
    color: #347EF6;
    padding-top: 7px;
    padding-bottom: 7px;
    padding-left:15px;
    padding-right:15px;
    text-decoration: none;
    cursor: pointer;
    font-size: ${props => props.fontSize};
    width: 200px;
    &:hover {
        text-decoration: none;
        color: #347EF6;
    }

    ${props =>
        props.primary &&
        css`
            border-width: 1px;
            border-color: #347EF6;
            background-color: #347EF6;
            color: white;
            font-weight: 500;

            &:hover {
                text-decoration: none;
                color: white;
            }
        `};
    
    ${props => 
        props.shadow &&
        css`
            box-shadow: 0px 1px 3px grey;
        `}
    
    ${props => 
        props.block &&
        css`
            width: 100%;
        `}
    ${props => 
        props.centered &&
        css`
            text-align: center;
        `}
`

export default ATagButton